import FormsUtil from "./formsUtil";

export let FormMixin = (superClass) => class extends superClass {
    constructor() {
        super();
    }

    static get properties() {
        return {}
    }

    ready() {
        super.ready();
    }

    /**
     * Sets the translation properties in the component if they weren't set as an attribute
     * @param {string} language - language code
     * @param {string} country - country code
     * @param trans - map of translations, keyed by language;
     * @see <a href="https://bitbucket.nuskin.net/projects/NA/repos/webcomponents-ui/browse/src/main/content/webcomponents/js/packages/elements-forms/src/ns-address/address-translations.js">Example Translations</a>
     * for example of the expected object structure
     * @private
     */
    _localize(language, country, trans, serverTranslations, useServerTranslations = false) {
        if (trans && language && country && language.length === 2 && country.length === 2) {
            let translations = FormsUtil.getTranslations(language, country, trans);
            let allTranslations;
            if (useServerTranslations) {
                allTranslations = Object.assign({}, translations, serverTranslations)
            } else {
                allTranslations = translations
            }

            if (allTranslations) {
                Object.keys(allTranslations).forEach((key) => {
                    //If the attribute was passed into the component then don't overwrite it.
                    if (!this.attributes.hasOwnProperty(FormsUtil.camelToHyphen(key))) {
                        this[key] = allTranslations[key];
                    }
                });
            }
        }
    }

    /**
     * Sets the config properties in the component if they weren't set as an attribute
     * @param {string} country
     * @param {Object} configuration - map of configuration settings, keyed by country;
     * @see <a href="https://bitbucket.nuskin.net/projects/NA/repos/webcomponents-ui/browse/src/main/content/webcomponents/js/packages/elements-forms/src/ns-city-state-zip/city-state-zip-config.js">Example Config</a>
     * for example of the expected object structure
     * @private
     */
    _setConfig(country, configuration) {
        if (country && country.length == 2) {
            let config = configuration[this.country];

            if (config) {
                Object.keys(config).forEach((key) => {
                    if (!this.attributes.hasOwnProperty(FormsUtil.camelToHyphen(key))) {
                        this[key] = config[key];
                    }
                });
            }
        }
    }

    /**
     * Updates the dirty flag on the form.
     *
     * @param args dirty flags on form elements that are being observed.
     * @private
     */
    _updateDirtyFlag(...args) {
        this.dirty = false;

        this.dirty = args.some(arg => arg === true);
    }

    /**
     * clearForm is called to clear state that exists on the form or elements
     *  within this form.  It can be a recursive call if this form has other
     *  forms within it.
     */
    clearForm() {
        let nodes = this.shadowRoot.querySelectorAll('*');

        // Handle dirty flag on form component like ns-shipping-address
        if (this.dirty !== undefined) {
            this.dirty = false;
        }

        // Handle children
        nodes.forEach(node => {
            if (node.clear) {
                node.clear();
            } else if (node.clearForm) {
                node.clearForm();
            }
        });
    }
};